<template>
  <div class="grid dashboard">
    <div class="col-12">
      <div class="card">
        <DataTable
          :value="displayedCarteras"
          :loading="loading"
          :lazy="true"
          :paginator="true"
          :rows="tamPagina"
          :totalRecords="carteras.length"
          class="p-datatable-responsive"
          :selection.sync="selectedCarteraUsuario"
          selectionMode="single"
          dataKey="id"
          @page="onPage"
          @row-select="onRowClick"
          @row-unselect="onRowClick(null)"
        >
          <template #header>
            <div class="table-header">
              {{
                tituloHeader ? tituloHeader : $t("common.titulos.seleccione")
              }}
            </div>
          </template>

          <template #empty>
            {{ $t("common.noResultados") }}
          </template>

          <Column
            :header="$t('common.campos.seleccionar')"
            filterMatchMode="equals"
          >
            <template #body="slotProps">
              <Button
                type="button"
                :icon="obtenerIconoAccion(slotProps.data)"
                :class="obtenerClaseIconoAccion(slotProps.data)"
                style="margin-right: 0.5em"
                @click="handleOnActionButtonClick(slotProps)"
              ></Button>
            </template>
          </Column>

          <div v-if="showUsuarioColumns">
            <Column
              field="usuarioCliente.nombre"
              :header="$t('usuario.nombre')"
              :sortable="false"
            >
              <template #body="slotProps">
                {{ slotProps.data.usuarioCliente.nombre }}
              </template>
            </Column>

            <Column
              field="usuarioCliente.apellidos"
              :header="$t('usuario.apellidos')"
              :sortable="false"
            >
              <template #body="slotProps">
                {{ slotProps.data.usuarioCliente.apellidos }}
              </template>
            </Column>

            <Column
              field="nombre"
              :header="$t('cartera.campos.cartera')"
              :sortable="false"
            >
              <template #body="slotProps">
                {{ slotProps.data.nombre }}
              </template>
            </Column>

            <Column
              field="usuarioCliente.idLegal"
              :header="$t('usuario.idLegal')"
            >
              <template #body="slotProps">
                {{ slotProps.data.usuarioCliente.idLegal }}
              </template>
            </Column>
          </div>

          <div v-if="showCarteraColumns">
            <Column
              field="nombre"
              :header="$t('cartera.campos.nombre')"
              :sortable="false"
            >
              <template #body="slotProps">
                {{ slotProps.data.nombre }}
              </template>
            </Column>

            <Column
              field="cartera.descripcion"
              :header="$t('cartera.campos.descripcion')"
              :sortable="false"
            >
              <template #body="slotProps">
                {{ slotProps.data.descripcion }}
              </template>
            </Column>

            <Column
              field="cartera.referenciaCliente"
              :header="$t('cartera.campos.referenciaCliente')"
              :sortable="false"
            >
              <template #body="slotProps">
                {{ slotProps.data.referenciaCliente }}
              </template>
            </Column>
          </div>
        </DataTable>
      </div>
    </div>
  </div>
</template>
<script>
import DatesMixin from "@/utils/dates";
import StringsMixin from "@/utils/strings";
import UsersMixin from "@/utils/users";
import TablesMixin from "@/utils/tables";

export default {
  name: "ListadoCarterasUsuario",
  mixins: [DatesMixin, StringsMixin, UsersMixin, TablesMixin],
  props: [
    "filters",
    "tituloHeader",
    "showCarteraColumns",
    "showUsuarioColumns",
    "selectedCarteraUsuarioValue",
  ],
  data() {
    return {
      tamPagina: 10,
      sort: ["-cartera.id"],
      loading: true,
      selectedCarteraUsuario: this.selectedCarteraUsuarioValue,
      carteras: [],
      displayedCarteras: [],
    };
  },
  created() {
    this.$store.state.cartera.results.forEach((cartera) => {
      if (cartera.cartera.usuarioCliente && cartera.cartera.operativa) {
        cartera.cartera.optionLabel =
          cartera.cartera.nombre +
          "-" +
          this.getFullName(
            cartera.cartera.usuarioCliente.nombre,
            cartera.cartera.usuarioCliente.apellidos,
            null
          );
        this.carteras.push(cartera.cartera);
      }
    });
  },
  mounted() {
    this.selectedCarteraUsuario = this.carteras[0];
    this.publishOnCarteraUsuarioClick(this.selectedCarteraUsuario);
    this.loading = false;
    this.displayedCarteras = this.carteras;
  },
  methods: {
    onRowClick(event) {
      const carteraUsuario = event ? event.data : null;

      this.publishOnCarteraUsuarioClick(carteraUsuario);
    },
    publishOnCarteraUsuarioClick(carteraUsuario) {
      this.$emit("cartera-usuario-click", carteraUsuario);
    },
    obtenerIconoAccion(data) {
      return this.selectedCarteraUsuario &&
        this.selectedCarteraUsuario.id === data.id
        ? this.actions.selected.icon
        : this.actions.unselected.icon;
    },
    obtenerClaseIconoAccion(data) {
      return this.selectedCarteraUsuario &&
        this.selectedCarteraUsuario.id === data.id
        ? this.actions.selected.buttonClass
        : this.actions.unselected.buttonClass;
    },
    handleOnActionButtonClick(slotProps) {
      this.selectedCarteraUsuario &&
      this.selectedCarteraUsuario.id === slotProps.data.id
        ? this.onCarteraUsuarioButtonClick()
        : this.onCarteraUsuarioButtonClick(slotProps.data);
    },
    onCarteraUsuarioButtonClick(data) {
      this.selectedCarteraUsuario = data;
      this.publishOnCarteraUsuarioClick(data);
    },
    onPage(event) {
      this.pageIndex = event.page;
      this.displayedCarteras = this.carteras.slice(
        this.pageIndex * this.tamPagina
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  background-color: transparent;
}
</style>